import styled, { css } from 'styled-components';
import IconComponent from '../Icon';

export const CardButton = styled.button(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: none; // resets default style
    border: 0; // resets default style
    padding: 0; // resets default style
    color: inherit;
    cursor: pointer;
    text-align: left;
    ${theme.typography.heading.desktop.xxs}
  `,
);

export const CardDescription = styled.div<{ $collapsed: boolean }>(
  ({ $collapsed, theme }) => css`
    display: ${$collapsed ? 'none' : 'block'};
    background-color: ${theme.co.neutral98};
    ${theme.typography.paragraph.base}

    margin: ${theme.sz.s6} -${theme.sz.s6} -${theme.sz.s6} -${theme.sz.s6};
    padding: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s2} -${theme.sz.s2} -${theme.sz.s2} -${theme.sz.s2};
      padding: ${theme.sz.s2};
    }
  `,
);

export const CollapsibleCard = styled.div(
  ({ theme }) => css`
    width: 100%;
    background-color: ${theme.co.neutral99};
    border: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    color: ${theme.co.neutral20};
    cursor: pointer;
    overflow: hidden;
    white-space: break-spaces;

    padding: ${theme.sz.s6};
    border-radius: ${theme.bo.mediumLarger};

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s2};
      border-radius: ${theme.bo.mediumSmall};
    }
  `,
);

export const Icon = styled(IconComponent)<{ $collapsed?: boolean }>(
  ({ $collapsed, theme }) => css`
    font-size: ${theme.sz.s6};
    line-height: ${theme.sz.s5};
    transform: rotate(${$collapsed ? '0deg' : '180deg'});
  `,
);
